// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"528":"codemirror","909":"notifications","961":"returns"}[chunkId] || chunkId) + "." + {"483":"168739c6668b31827041","487":"d7d9d856c01510622d01","528":"dde3c144f64b968161e7","909":"ef48274c6e21eec2ece7","961":"ed2db4c8b98f6252e023"}[chunkId] + ".js";
};